import { AppView, TitlebarView, VideoView, LivescoreWidget, WIDGET_LIVESCORE } from "@gaming/srvg-classes-core";
import { MatchdayArea } from "../MatchdayArea";

export class TerminalCompactView extends AppView {
    titlebar: TitlebarView;
    videoView: VideoView;
    widgetLivescore: LivescoreWidget;
    matchdayArea: MatchdayArea;

    constructor(options){
        options = options || {};
        options.selector = options.selector || '#vbl_container';
        super(options);

        /******************* initialize views ************************/

        this.titlebar = this.addSubView( new TitlebarView( { selector: '#titlebar' } ) );

        var hdChannel = null;
        if( srvg.videooptions.alt_videobasename ) {
            if( !srvg.featuresInstances.getStartWithHd() ) {
                hdChannel = srvg.videooptions.serverurl+srvg.videooptions.videobasename;
            }
            else {
                hdChannel = srvg.videooptions.serverurl+srvg.videooptions.alt_videobasename;
            }
        }

        // Setting the videoHandlers order for the videoView
        var videoHandlers = [];
        if (srvg.Player.getWorkingStreamType() == 'flash') {
            videoHandlers = ['flash', 'hls', 'html5'];
        } else {
            videoHandlers = ['hls', 'flash', 'html5'];
        }

        this.videoView = this.addSubView( new VideoView( {
            playerOptions: {
                hdChannel: hdChannel,
                hdswitch: null,
                overlays: '#overlay',
                useLiveplayer: true,
                hidePlayButton: false,
                hideStopButton: true,
                hide:'display',
                muted: srvg.featuresInstances.getDisableAudioByDefault() || srvg.videooptions.startMute,
                vod: false,
                loglevel: 0,
                ui: {
                    enabled: true,
                    videoControls : false,
                    fullscreen : false,
                    controlBarHideDelay: 3
                },
                poster: srvg.url.image+'video/poster.png',
                noButton: false,
                autoplay: true,
                swf: srvg.url.webroot+'liveplayer/srplayer.swf',
                videoHandlers: videoHandlers,
                smoothTransition: false,
                gui: false,
                micro: false,
            }
        },srvg ) );


        this.widgetLivescore = null;

        if (srvg.widgets.enabled && (window as any).vswidgets.init ) {
            srvg.widgetLoader = (window as any).vswidgets.init({});
            var widgetList = [];
            var widgetGroup = 'VBL';

            if( srvg.widgets[WIDGET_LIVESCORE].enabled ) {
                this.widgetLivescore = this.addSubView(new LivescoreWidget({
                    singlePlayButton: false,
                    widgetGroup: widgetGroup,
                    numOfColumns: 1,
                    platform: 'desktop-extrasmall',
                    showRaceToX: false,
                    showTablePosition: false
                }));
                widgetList.push( this.widgetLivescore );
            }

            srvg.eventExchange.addEventHandler(widgetList, 'all', 'addWidget', 'handleAddWidgetEvent');
            srvg.eventExchange.addEventHandler(widgetList, 'all', 'destroyWidget', 'handleDestroyWidgetEvent');
        }

        this.matchdayArea = this.addSubView( new MatchdayArea({
            hasMatchdayPicker: true,
            hasOddsGallery: true,
            oddsGallery: null
        }) );

        var that = this;

    }
}